import { useId, useState } from 'react';
import { connect } from 'react-redux';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Menu, MenuItem } from '@mui/material';
import { DeleteOutline, FlagOutlined, MoreHorizRounded, ThumbDown, ThumbDownOutlined, ThumbUp, ThumbUpOutlined } from '@mui/icons-material';
import PreviewReportIssueDrawer from './PreviewReportIssueDrawer';

const NoteOptionsComponent = ({ note, deleteNote, authenticated, uid }) => {
    const [menuAnchor, setMenuAnchor] = useState(null);
    const [confirmDelete, setConfirmDelete] = useState(false);
    const [showReport, setShowReport] = useState(false);
    const isOwner = note.uid === uid;
    if (!authenticated) return null;

    const chooseAction = () => {
        setMenuAnchor(null);
        if (isOwner) setConfirmDelete(true);
        else setShowReport(true);
    };
    const removeNote = () => {
        setConfirmDelete(false);
        deleteNote(note.id)();
    };

    return <>
        <button type='button' className='notesOptionsButton notesCardOptions' onClick={event => setMenuAnchor(event.currentTarget)}
            aria-label={isOwner ? 'Your note options' : 'Listener note options'} aria-haspopup='menu' aria-expanded={Boolean(menuAnchor)}>
            <MoreHorizRounded aria-hidden='true' />
        </button>
        <Menu anchorEl={menuAnchor} open={Boolean(menuAnchor)} onClose={() => setMenuAnchor(null)} PaperProps={{ className: 'notesPopup' }}>
            <MenuItem onClick={chooseAction} className={isOwner ? 'notesDestructive' : undefined}>
                {isOwner ? <DeleteOutline /> : <FlagOutlined />}<span>{isOwner ? 'Delete note' : 'Report note'}</span>
            </MenuItem>
        </Menu>
        <Dialog open={confirmDelete} onClose={() => setConfirmDelete(false)} aria-labelledby={`delete-note-${note.id}`} PaperProps={{ className: 'notesPopup' }}>
            <DialogTitle id={`delete-note-${note.id}`}>Delete note?</DialogTitle>
            <DialogContent><DialogContentText>This note will be permanently deleted.</DialogContentText></DialogContent>
            <DialogActions>
                <Button onClick={() => setConfirmDelete(false)}>Cancel</Button>
                <Button onClick={removeNote} color='error'>Delete note</Button>
            </DialogActions>
        </Dialog>
        <PreviewReportIssueDrawer open={showReport} onClose={() => setShowReport(false)} contentType='note' contentId={note.id} />
    </>;
};

const NoteActions = ({ note, votes, voteUp, voteDown }) => {
    const countId = useId();
    const vote = votes?.[note.id];
    const showVoteCounts = vote?.voteStatus !== undefined && vote?.voteStatus !== null;
    return <div className='notesVotes'>
        <button type='button' onClick={voteUp(note.id)} className='notesVoteButton' aria-label='Upvote note' aria-pressed={vote?.voteStatus === true} aria-describedby={showVoteCounts ? `${countId}-up` : undefined}>
            {vote?.voteStatus === true ? <ThumbUp /> : <ThumbUpOutlined />}
            {showVoteCounts && <span id={`${countId}-up`}>{note.upVotes ?? 0}</span>}
        </button>
        <button type='button' onClick={voteDown(note.id)} className='notesVoteButton' aria-label='Downvote note' aria-pressed={vote?.voteStatus === false} aria-describedby={showVoteCounts ? `${countId}-down` : undefined}>
            {vote?.voteStatus === false ? <ThumbDown /> : <ThumbDownOutlined />}
            {showVoteCounts && <span id={`${countId}-down`}>{note.downVotes ?? 0}</span>}
        </button>
    </div>;
};

const mapStateToProps = state => ({ authenticated: state.user.authenticated, uid: state.user.uid });
export const NoteOptions = connect(mapStateToProps)(NoteOptionsComponent);
export default NoteActions;
